import { createSelector } from '@reduxjs/toolkit';

import { zoomChange } from '../../components/map/layerStyles';
import { selectIsClimate } from '../options/options.selector';

const selectMap = (state) => state.map;

export const selectViewState = createSelector(
  selectMap,
  (mapState) => mapState.viewState
);

export const selectShowCountyOverride = createSelector(
  selectMap,
  (mapState) => mapState.showCountyOverride
);

export const selectIsCountyLevel = createSelector(
  selectMap,
  selectShowCountyOverride,
  (mapState, override) => mapState.viewState.zoom >= zoomChange || override
);

export const selectCurrentLocation = createSelector(
  selectMap,
  (mapState) => mapState.currentLocation
);

export const selectShowStations = createSelector(
  selectViewState,
  selectIsClimate,
  (viewState, isClimate) => isClimate && viewState.zoom >= 6.7
);

export const selectCurrentStation = createSelector(
  selectMap,
  (mapState) => mapState.currentStation
);

export const selectUseStationData = createSelector(
  selectShowStations,
  selectCurrentStation,
  (showStation, currentStation) => showStation && currentStation.sid
);

export const mapboxToken = process.env.REACT_APP_MAPBOX_TOKEN;